<template>
  <v-dialog persistent v-model="dialog" max-width="590">
    <v-card>
      <v-card-text>
        <v-card class="pt-5">
          <v-toolbar color="cyan" dark flat>
            <v-toolbar-title>Cadastro de abastecimento</v-toolbar-title>
          </v-toolbar>
          <v-card flat>
            <v-card-text>
              <v-flex md8>
                <label for="model">Valor do abastecimento:</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text font-weight-medium"
                      id="basic-addon1"
                    >
                      R$
                    </span>
                  </div>
                  <money
                    v-bind="money"
                    v-model="supplyValue"
                    class="form-control"
                  ></money>
                </div>
              </v-flex>
            </v-card-text>

            <v-card-text>
              <h6>Adicionar comprovante</h6>
              <v-file-input v-model="image" show-size counter> </v-file-input>
            </v-card-text>
          </v-card>
        </v-card>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="$emit('disagree')">
          Cancelar
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click="createSupplyByVehicleRequest"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NumberHelper from '../../helpers/NumberHelper';

export default {
  props: {
    dialog: Boolean,
    vehicleRequestId: Number,
  },
  data: () => ({
    supplyValue: 0.0,
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: true,
    },
    formImages: {},
    image: null,
  }),
  methods: {
    createSupplyByVehicleRequest() {
      let integerSupplyValue = NumberHelper.convertMoneyToInteger(
        this.supplyValue
      );
      this.$emit(
        'agree',
        integerSupplyValue,
        this.image,
        this.vehicleRequestId
      );
    },
  },
};
</script>
